// ═══════════════════════════════════════════════════════════
// useRadioAudio — un único elemento de audio, compartido
// ═══════════════════════════════════════════════════════════
//
// La emisión suena en un solo `<audio>`, que hoy vive dentro de PlayerSite y
// se monta una vez en toda la aplicación. Cualquier otra pieza que necesite esa
// señal —la onda del transporte, por ejemplo— tiene que llegar al MISMO
// elemento: `createMediaElementSource` solo admite una llamada por elemento, y
// un segundo `<audio>` con el mismo stream sonaría dos veces.
//
// Este registro es el punto de encuentro. PlayerSite deposita su elemento al
// montarse y quien lo necesite lo recoge. Es deliberadamente tonto: un ref de
// módulo, sin estado ni lógica.
//
// Provisional por diseño: cuando C3 rehaga PlayerSite, el elemento pasará a
// vivir donde le corresponda y esto se cae.
import { shallowRef } from "vue";

const el = shallowRef(null);

export function useRadioAudio() {
  function register(element) {
    el.value = element || null;
  }

  return { audioEl: el, register };
}
